import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useAuth } from '../context/AuthContext';

const toSnackbarMessage = message => {
    if (typeof message === 'string') {
        return message;
    }
    if (Array.isArray(message)) {
        return message.join(', ');
    }
    if (message && typeof message === 'object' && typeof message.message === 'string') {
        return message.message;
    }
    return 'Serviço indisponível';
};

const getResponseErrorMessage = responseData => {
    if (typeof responseData?.message === 'string' && responseData.message.trim()) {
        return responseData.message;
    }

    if (Array.isArray(responseData?.errors)) {
        const messages = responseData.errors
            .map(item => item?.description || item?.detail || item?.message || item?.code)
            .filter(Boolean);

        if (messages.length) {
            return messages.join(' • ');
        }
    }

    return null;
};

const useHandleErrors = errors => {
    const { LogOut } = useAuth();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (!errors) {
            return;
        }

        if (!errors?.response) {
            if (errors.code === 'ERR_NETWORK') {
                enqueueSnackbar('Servidor desconectado');
            } else if (errors.message) {
                enqueueSnackbar(toSnackbarMessage(errors.message));
            }
            return;
        }

        const status = errors.response.status;
        const apiMessage = getResponseErrorMessage(errors.response?.data);

        switch (status) {
            case 401:
                LogOut();
                break;
            case 404:
                enqueueSnackbar(apiMessage || 'Recursos inexistente');
                break;
            default:
                enqueueSnackbar(
                    apiMessage ||
                        toSnackbarMessage(errors.message) ||
                        'Serviço indisponível',
                );
                break;
        }
    }, [errors, enqueueSnackbar, LogOut]);
};

export default useHandleErrors;
